import { setCookie, getCookie } from '../utils';

const options = {
    item: 'js-geo-modal',
    close: 'js-close',
    link: 'js-link',
    session: 'iqeq_geo_popup',
    dialog: 'js-geo-modal__dialog',
}

const geolocation = {
    init() {
        const item = document.getElementsByClassName(options.item);
        const modals = [...item];

        modals.forEach((modal) => {
            const dialog = modal.getElementsByClassName(options.dialog);
            const post_id = modal.getAttribute('data-post-id');
            const session_version = modal.getAttribute('data-session-version') ?? '1.0.0';
            const session_length = modal.getAttribute('data-session-length') ?? 90;
            let linkBtns = [];
            let closeBtns = [];

            dialog[0].setAttribute('open', true);

            if (!getCookie(`${options.session}_${session_version}`)) {
                geolocation.fetchData('geoLocation', {
                    post_id: JSON.stringify(post_id),
                }).then((results) => {
                    if (results.data && results.data.length > 0) {
                        const linkBtn = modal.getElementsByClassName(options.link);
                        const closeBtn = modal.getElementsByClassName(options.close);
                        setTimeout(() => {
                            dialog[0].innerHTML = results.data;
                            linkBtns = [...linkBtn];
                            closeBtns = [...closeBtn];
                            geolocation.linkEvent(linkBtns, session_version, session_length);
                            geolocation.closeEvent(closeBtns, session_version, session_length);
                            modal.classList.add('active');
                        }, 10000);
                    }
                }).catch((err) => console.error(err));
            }
        });
    },

    linkEvent(buttons, session_version, session_length) {
        buttons.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                const target = e.target;

                if (!getCookie(`${options.session}_${session_version}`)) {
                    setCookie(`${options.session}_${session_version}`, 'true', session_length);
                }

                window.location.href = target.href;
            });
        })
    },

    closeEvent(buttons, session_version, session_length) {
        buttons.forEach((close) => {
            close.addEventListener('click', (e) => {
                const target = e.target;

                if (!getCookie(`${options.session}_${session_version}`)) {
                    setCookie(`${options.session}_${session_version}`, 'true', session_length);
                }

                target.closest(`.${options.item}`).classList.remove('active');
            });
        })
    },

    fetchData(action, data = {}) {
        return fetch(
            window.cdScriptsObj?.ajax_url || '/wp-admin/admin-ajax.php',
            {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({ action, ...data }),
            },
        ).then((response) => response.json());
    }
}

export default geolocation;
